import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';

/** 
 * Show Time in HH:mm
 * time is in unix milliseconds
*/
@Pipe({ name: 'showTime'})
export class ShowTimePipe implements PipeTransform {
    transform(time: number): string {
        return dayjs(time).format('h:mm A');
    }
}

/**
* Takes Unix milliseconds and returns fuzzy human-readable time delta
* 
* @param value unix time
*/
@Pipe({ name: 'fromNow'})
export class FromNowPipe implements PipeTransform {
    transform(time: number): string {
        dayjs.extend(relativeTime);
        return dayjs(time).fromNow();
    }
}